import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '../custom-header/components/components.module';
import { ConfigModule } from '@spartacus/core';
import { CustomCxNavigationComponent } from './components/custom-cx-navigation/custom-cx-navigation.component';
import { CustomCxMiniCartComponent } from './components/custom-cx-mini-cart/custom-cx-mini-cart.component';
import { CustomCxLoginComponent } from './components/custom-cx-login/custom-cx-login.component';
import { UserAccountService } from '@spartacus/user/account/core';
import { CustomUserAccountService } from '../services/user-account.service';
import { CustomSearchboxComponent } from './components/custom-searchbox/custom-searchbox.component';
import { CustomCategoryNavigationComponent } from './components/custom-category-navigation/custom-category-navigation.component';
import { CustomBannerComponent } from './components/custom-banner/custom-banner.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CollapseModule } from 'ngx-bootstrap/collapse';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    CollapseModule,
    ComponentsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        MiniCartComponent: {
          component: CustomCxMiniCartComponent,
        },
        NavigationComponent: {
          component: CustomCxNavigationComponent,
        },
        // LanguageCurrencyComponent: {
        //   component: '', <--- es mejor usar display: none; para evitar warning logs
        // },
        LoginComponent: {
          component: CustomCxLoginComponent,
        },
        SearchBoxComponent: {
          component: CustomSearchboxComponent,
        },
        CategoryNavigationComponent: {
          component: CustomCategoryNavigationComponent,
        },
        SimpleBannerComponent: {
          component: CustomBannerComponent,
        }
      },
    }),
  ],
  providers: [{ provide: UserAccountService, useClass: CustomUserAccountService }],
})
export class CustomHeaderModule {}
